export default "__VITE_ASSET__BPrmMg3J__"